import {
  PresignWhatsAppInboxAttachmentBodySchema,
  PresignWhatsAppInboxAttachmentResponseSchema,
  type PresignWhatsAppInboxAttachmentBody,
  type PresignWhatsAppInboxAttachmentResponse,
} from '@zrsystem/contracts';

import { whatsappInboxApiPath } from '@/features/notification/api/whatsapp-inbox.api.js';
import { getHttpClient } from '@/shared/api/http-client.js';
import { uploadFileToPresignedUrl } from '@/shared/api/storage.api.js';

export async function presignWhatsAppInboxAttachment(
  placeId: string,
  body: PresignWhatsAppInboxAttachmentBody,
): Promise<PresignWhatsAppInboxAttachmentResponse> {
  const payload = PresignWhatsAppInboxAttachmentBodySchema.parse(body);
  const raw = await getHttpClient().post<unknown>(
    whatsappInboxApiPath(placeId, '/attachments/presign'),
    payload,
  );
  return PresignWhatsAppInboxAttachmentResponseSchema.parse(raw);
}

function contentTypeForInboxFile(file: File): string {
  if (file.type.length > 0) {
    return file.type;
  }
  const name = file.name.toLowerCase();
  if (name.endsWith('.mp4')) return 'video/mp4';
  if (name.endsWith('.mov')) return 'video/quicktime';
  if (name.endsWith('.webm')) return 'video/webm';
  if (name.endsWith('.3gp')) return 'video/3gpp';
  if (name.endsWith('.mkv')) return 'video/x-matroska';
  return 'application/octet-stream';
}

export async function uploadWhatsAppInboxAttachment(
  placeId: string,
  file: File,
): Promise<{ storageKey: string; contentType: string }> {
  const contentType = contentTypeForInboxFile(file);
  const presign = await presignWhatsAppInboxAttachment(placeId, {
    contentType,
    contentLength: file.size,
  });
  await uploadFileToPresignedUrl(presign.uploadUrl, file);
  return { storageKey: presign.storageKey, contentType };
}
